import { useState } from 'react'
import styled from 'styled-components'
import { Typography } from 'common/typography'
import Link from 'next/link'
import { SecondaryButton, TransparentButton } from 'common/button'
import { useStudentsPodium } from 'querys/student-projects'
import LoadingState from 'common/loading-state'
import PointsModal from 'projects/students/podium/points-modal'
import { IoMdAlert } from 'react-icons/io'

const PodiumBarStyled = styled.div`
  margin-block-end: 3rem;
  .photo-list {
    position: relative;
    height: 34px;
    inline-size: 255px;
  }
  .podium-list-container {
    margin-block-start: .5rem;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
  .podium-title {
    display: flex;
    align-items: center;
  }
  @media (min-width: 768px) {
    .podium-list-container {
      flex-direction: row;
      align-items: flex-end;
    }
  }
`

const PodiumPhoto = styled.li`
  position: absolute;
  transition: 0.2s ease transform;
  transform: ${({ idx }) => `translateX(${idx * 65}%)`};
  cursor: pointer;
  &:hover {
    z-index: 1;
    transform: ${({ idx }) => `translateX(${idx * 65}%) translateZ(5px) scale(1.1)`};
  }
  img {
    border: 2px solid var(--white);
    border-radius: 50%;
    overflow: hidden;
  }
`

function PodiumBar() {
  const [points, setPoints] = useState(false)
  const { data, isLoading } = useStudentsPodium({ defaultPeriod: 'monthly' })

  if (isLoading) {
    return (
      <LoadingState height="72px" width="auto" />
    )
  }

  return (
    <PodiumBarStyled>
      <div className="podium-title">
        <Typography as="h4" font="regular">
          Estudiantes destacados
        </Typography>
        <TransparentButton color="var(--turquoise)" onClick={() => setPoints(true)}>
          <IoMdAlert size={20} />
        </TransparentButton>
      </div>
      <div className="podium-list-container">
        <ul className="photo-list">
          {data.length > 0 ? (
            <>
              {data?.slice(0, 11).map(({ username, photo, full_name }, idx) => (
                <PodiumPhoto className="photo-list-item" idx={idx}>
                  <a href={`/estudiante/${username}`} title={username} target="_blank" rel="noopener noreferrer">
                    <img src={photo} alt={full_name} width="30" height="30" />
                  </a>
                </PodiumPhoto>
              ))}
            </>
          ) : (
            <Typography font="p2Regular" color="var(--turquoise)">
              Puedes ser el estudiante 1º en el podium semanal
            </Typography>
          )}
        </ul>
        <Link href="/podium" passHref>
          <SecondaryButton>
            Ver todo el podio
          </SecondaryButton>
        </Link>
      </div>
      <PointsModal points={points} setPoints={setPoints} />
    </PodiumBarStyled>
  )
}

export default PodiumBar
